import axios from 'axios';
import { ChilizConfigProvider } from '../config/configProvider'
import { useMemo } from 'react'
import { useChainId } from 'wagmi';
import { useQuery } from '@tanstack/react-query';

export const useDynamicSetting = <T = unknown>({ key, defaultValue }: { key: string; defaultValue?: T }) => {
	const networkId = useChainId()
	const config = useMemo(() => new ChilizConfigProvider(), [])
    const chainDetails = config.getConfig(networkId)

	return useQuery<T>({
		queryKey: [chainDetails.backendUrl, 'dynamic-setting', key],
		queryFn: async () => {
			try {
				const { data } = await axios.get(`${chainDetails.backendUrl}dynamic-settings/${key}`)
				const value = data?.[key]

				try {
					const parsed = JSON.parse(value)

					return parsed
				} catch {
					return typeof value === 'string' ? (value as T) : defaultValue ? defaultValue : null
				}
			} catch {
				return defaultValue ?? null
			}
		},
		staleTime: 1000 * 60 * 10
	})
}